import { useEffect } from 'react';

interface UsePlayerKeyboardShortcutsProps {
  togglePlay: () => void;
  skipForward: () => void;
  skipBackward: () => void;
  isEnabled?: boolean;
}

const usePlayerKeyboardShortcuts = ({
  togglePlay,
  skipForward,
  skipBackward,
  isEnabled = true,
}: UsePlayerKeyboardShortcutsProps) => {
  useEffect(() => {
    if (!isEnabled) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      // Ignore if user is typing in an input field
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
      }

      switch (e.key) {
        case ' ':
          e.preventDefault();
          togglePlay();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          skipBackward();
          break;
        case 'ArrowRight':
          e.preventDefault();
          skipForward();
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isEnabled, togglePlay, skipBackward, skipForward]);
};

export default usePlayerKeyboardShortcuts;
